import { rem } from "polished";
import styled, { css } from "styled-components";

const TabWrapper = ({ children, isSticky = false }) => {
  return <TabLayout isSticky={isSticky}>{children}</TabLayout>;
};
export default TabWrapper;

const TabLayout = styled.div`
  ${({ theme, isSticky }) => css`
    .AccordionRoot {
    }

    .AccordionItem {
    }

    .TabsList {
      ${isSticky &&
      css`
        position: sticky;
        top: 0;
         background-color: #f8f8f8;
      `}
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: ${rem(30)};
      /* border-top: 50px solid transparent; */
      border-bottom: 50px solid transparent;
      z-index: 4;

      .TabsTrigger {
        background-color: ${theme.colors.gray[500]};
        border: none;
        border-radius: 0;
        color: ${theme.colors.black};
        padding: 15px;
        cursor: pointer;
        transition: 0.3s ease all;
        min-width: 250px;

        &[data-state="active"] {
          background-color: ${theme.colors.primary};
          color: ${theme.colors.white};
        }

        @media (max-width: 991px) {
          min-width: auto;
        }
      }
    }

    .AccordionTrigger {
      width: 100%;
      padding: ${rem(20)} ${rem(30)} ${rem(20)} ${rem(15)};
      transition: 0.3s ease all;
      position: relative;
      border: none;
      text-align: left;

      &::after {
        content: "";
        top: calc(50% - 3px);
        right: 15px;
        position: absolute;
        transform: translateY(-50%) rotate(45deg);
        border-style: solid;
        border-width: 0 1px 1px 0;
        display: inline-block;
        padding: 6px;
        transition: 0.3s ease all;
      }

      &[data-state="open"] {
        background-color: ${theme.colors.primary};
        color: ${theme.colors.white};

        &::after {
          border-color: ${theme.colors.white};
          transform: translateY(-50%) rotate(225deg);
          transform-origin: 9px 9px;
        }
      }
      &[data-state="closed"] {
        background-color: ${theme.colors.gray[500]};
        color: rgba(0, 0, 0, 0.48);

        &::after {
          border-color: ${theme.colors.black};
        }
      }
    }
    .AccordionContent {
      &[data-state="open"] {
        animation: slideDown 300ms cubic-bezier(0.87, 0, 0.13, 1);
      }
      &[data-state="closed"] {
        animation: slideUp 300ms cubic-bezier(0.87, 0, 0.13, 1);
      }
    }

    @keyframes slideDown {
      from {
        height: 0;
      }
      to {
        height: var(--radix-accordion-content-height);
      }
    }

    @keyframes slideUp {
      from {
        height: var(--radix-accordion-content-height);
      }
      to {
        height: 0;
      }
    }
  `}
`;
